import React, {useEffect, useState} from 'react'
import api from '../service/api'

import NavBar from '../components/navbar'

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPhone, faGlobe, faAt, faFrown, faLink} from '@fortawesome/free-solid-svg-icons'

export default function Startup({match}){
    
    const startupId = match.params.id

    const [startup, setStartup] = useState({})

    useEffect(() => {
        async function loadStartup(){
            const response = await api.get('/open/startups?_id=' + startupId)
            setStartup(response.data[0])
        }
            
        loadStartup()
    },[startupId])
        
    return(
        <div id="startup">
            <NavBar bgColor="rgb(192,81,44)"/>

            {
                (Object.getOwnPropertyNames(startup).length !== 0)
                ? (<div className="card col-sm-6 mx-auto mt-5 pt-5 p-0 border-0 shadow-lg">    
                    <img data-toggle="modal" className="card-img-top" src={api.defaults.baseURL + startup.fotoUrl} alt=""/>
                    
                    <div className="card-body">
                    <h5 id="titulo" className="card-title font-weight-bold">{startup.nome}</h5>
                    <p id="descricao" className="card-text">{startup.descricao}</p>
                    </div>
                    <div className="card-footer">
                            <p className="card-text">
                            <FontAwesomeIcon icon={faPhone} style={{color: "rgb(68, 1, 91)"}} /> {startup.telefone}
                            </p>

                            <p className="card-text">
                            <FontAwesomeIcon icon={faLink} style={{color: "rgb(68, 1, 91)"}} /> {startup.site}
                            </p>
                        </div>
                    </div>
                )
                :<span className="text-center h-100 m-0 p-0 row justify-content-center align-items-center">
                    <div className="column">
                        <FontAwesomeIcon icon={faFrown} style={{color: "rgb(192,81,44)", fontSize: "250"}}/> <br/>
                        <h4 className="mt-3 text-secondary">O conteúdo solicitado não foi encontrado</h4>
                    </div>
                </span> 
            }
    </div>
    )
}